import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'

const routes = {
  root: `${simulatorTrainingRoutes.instructorIL}/simulator/list`,
}

export default routes
